import { getInfo } from '@Components/Grid/components/Table/formatters';

export default function FrequencyFormatter({ info }) {
  const { value } = getInfo(info)
  const frequency = FREQUENCY_OPTIONS[value]

  if (!frequency) {
    return '--'
  }

  return frequency
}

const FREQUENCY_OPTIONS = {
  d: 'Daily',
  w: 'Weekly',
  M: 'Monthly',
  y: 'Yearly',
  Q: 'Quarterly',
  S: 'Semi-yearly',
  static: 'Just Once',
}
